// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"73993e7d","35":"289904dd","97":"95f4e8ae","352":"6c1ced3f","372":"e9f7b27c","969":"430d2dbf"}[chunkId] + ".chunk.js";
};